var map = {
	"./flag-1.gif": 408,
	"./flag-10.gif": 409,
	"./flag-11.gif": 410,
	"./flag-12.gif": 411,
	"./flag-13.gif": 412,
	"./flag-14.gif": 413,
	"./flag-15.gif": 414,
	"./flag-16.gif": 415,
	"./flag-17.gif": 416,
	"./flag-18.gif": 417,
	"./flag-2.gif": 418,
	"./flag-3.gif": 419,
	"./flag-4.gif": 420,
	"./flag-5.gif": 421,
	"./flag-6.gif": 422,
	"./flag-7.gif": 423,
	"./flag-8.gif": 424,
	"./flag-9.gif": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;